import { required, obj } from 'AppReact/schema';

const budget = {
  amount: required('integer'),
  month: required('integer'),
  id: required('number'),
}


export default {
  budget: obj(budget),
  id: required('integer'),
  name: required('string'),
  year: required('integer'),
  spent: required('string'),
}
